export class InvoiceVoucherDetail {

  public Id: string;

  public VoucherDepartment: string;

  public VoucherAnalyticalSection: string;

  public VoucherAnalyticalCode: string;

  public VoucherComment: string;
}
